<app-modal-template
  [title]="title"
  [size]="renderedAsMatBottomSheet ? pencilModalSizeEnum.FULL_WIDTH : size"
  [hasCloseButton]="hasCloseButton"
  [ngStyle]="{ '--modal-template-gap': description ? '24px' : '0px' }"
  (closeButtonClicked)="handleCloseButtonClick($event)"
>
  <div
    class="descriptions-box"
    [innerHtml]="description"
    content-description
    *ngIf="description"
  ></div>
  <label content-description class="consent-checkbox">
    <input type="checkbox" (change)="isConsentGiven = !isConsentGiven" />
    <span>{{ consentCheckboxLabel }}</span>
  </label>
  <div class="actions-box" content-actions>
    <ng-container *ngIf="!customCancelButton">
      <app-pencil-button
        *ngIf="cancelButtonConfig"
        [theme]="'secondary-outline'"
        [icon]="cancelButtonConfig.icon"
        [iconConfig]="{ type: cancelButtonConfig.iconType }"
        [label]="cancelButtonConfig.label"
        (clickEvent)="handleCancelClick($event)"
      ></app-pencil-button>
    </ng-container>
    <ng-content select="[custom-cancel-button]"></ng-content>
    <app-pencil-button
      *ngIf="confirmButtonConfig"
      [theme]="confirmButtonConfig.danger ? 'danger' : 'primary'"
      [icon]="confirmButtonConfig.icon"
      [iconConfig]="{ type: confirmButtonConfig.iconType, outlined: confirmButtonConfig.outlined }"
      [label]="confirmButtonConfig.label"
      [disabled]="!isConsentGiven"
      (clickEvent)="handleConfirmClick($event)"
    ></app-pencil-button>
  </div>
</app-modal-template>
